import { useCallback } from "react";
import {
  launchApp,
  downloadApp,
  getDynamicUrl,
  getAppUrl,
} from "../../api/features/read-offline/actions";
import { useAppDispatch } from "../../../framework/api/core/useAppDispatch";
import { useBrand } from "../../../../../common/providers/brand/brand-context";
import { isTouchDevice } from "../../../../../common/utils/platform";

export default function useReadOffline() {
  const dispatch = useAppDispatch();
  const brand = useBrand();
  const readOfflineEnabled = brand.getProp("DownloadOffline.enabled");
  const readOfflineQrCodeSupported =
    readOfflineEnabled &&
    !isTouchDevice() &&
    brand.getProp("qrMobileSignIn.enabled");

  return {
    launchApp: useCallback(() => dispatch(launchApp()), [dispatch]),
    downloadApp: useCallback(() => dispatch(downloadApp()), [dispatch]),
    getDynamicUrl: useCallback(() => dispatch(getDynamicUrl()), [dispatch]),
    getAppUrl: useCallback(() => dispatch(getAppUrl()), [dispatch]),
    readOfflineEnabled,
    readOfflineQrCodeSupported,
  };
}
